<template>
    <q-card class="bg-primary text-white column full-height">
        <q-toolbar>
            <q-avatar>
                <q-btn flat round dense icon="terminal" />
            </q-avatar>
            <q-btn class="q-ml-lg" color="grey-2" text-color="black" icon="search" type="button" style="height: 40px"
                @click="getSerialPorts" />
            <q-select borderless class="q-ml-lg" bg-color="grey-2" filled dense v-model="baudrate"
                :options="baudrate_options" style="width: 200px">
            </q-select>
            <q-space />
            <q-btn flat round dense icon="close" v-close-popup />
        </q-toolbar>

        <q-card-section class="col q-pt-none">
            <q-scroll-area ref="log" class="bg-grey-9"
                style="max-width: 100%; height: calc(100% - 50px); padding-bottom: 10px">
                <div ref="log_messages" v-html="log">

                </div>
            </q-scroll-area>
            <q-input class="q-pt-sm" bg-color="grey-2" dense filled v-model="command" label="Command">
                <template v-slot:hint>
                    Command
                </template>
                <template v-slot:after>
                    <q-btn color="grey-2" round dense flat icon="send" @click="writeSerial" />
                </template>
            </q-input>
        </q-card-section>

    </q-card>
</template>
  
<style></style>
  
<script>
var port,
    textEncoder,
    textDecoder,
    reader,
    writer,
    readableStreamClosed;

export default {
    name: 'SerialTerminal',
    data() {
        return {
            command: '',
            keepReading: true,
            command_button: false,
            baudrate_options: [110, 300, 600, 1200, 2400, 4800, 9600, 14400, 19200, 38400, 57600, 115200, 128000, 256000],
            baudrate: 9600,
            log: '',
        }
    },
    methods: {
        async getSerialPorts() {
            try {
                port = await navigator.serial.requestPort();
                await port.open({ baudRate: this.baudrate });
                // Promise.all([this.readSerial("...")])
                this.readSerial();
            } catch (err) {
                console.log("Error found: ", err);
            }

        },
        writeSerial() {
            const text = this.command;
            console.log("command sent:", text)

            textEncoder = new TextEncoder();
            // writableStreamClosed = textEncoder.readable.pipeTo(port.writable);
            writer = port.writable.getWriter();
            writer.write(textEncoder.encode(text));
            writer.releaseLock();
            this.command = '';
        },
        async readSerial() {
            while (port.readable && this.keepReading) {
                textDecoder = new window.TextDecoderStream()
                readableStreamClosed = port.readable.pipeTo(textDecoder.writable)
                reader = textDecoder.readable.getReader()

                try {
                    for (; ;) {
                        const { value, done } = await reader.read()
                        if (done) {
                            break
                        }
                        if (value) {
                            var message = value.toString();
                            message = message.replace(/(?:\r\n|\r|\n)/g, "<br>");
                            this.log = this.log + message;
                            const scrollArea = this.$refs.log;
                            scrollArea.setScrollPosition("vertical", this.$refs.log_messages.scrollHeight + 10);
                        }
                    }
                } catch (error) {
                    console.error(error)
                } finally {
                    reader.releaseLock();
                }
            }
        },
        async closeSerial() {
            try {
                this.keepReading = false;
                reader.cancel();
                await readableStreamClosed.catch(() => { /* Ignore the error */ });
                await port.close();
            } catch {/* Ignore the error */}
        }
    }
}
</script>
  